import { Box, Button, Grid, Modal, Title } from '@mantine/core';
import { IconChevronLeft, IconChevronRight, IconPencil } from '@tabler/icons-react';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import MarketingChannelsFlow from './marketingChannelsFlow';

const GuidanceModal = ({ type, redirect, show, elementTypes, element, setShow, newElement, useInAutomation }) => {
  const navigate = useNavigate();
  const { accountId, domainId } = useParams();
  const [marketingChannelsFlow, setMarketingChannelsFlow] = useState(!!useInAutomation);

  let guidanceElements;
  let buttonRedirect;
  const typeToButtonRedirectMap = {
    email: 'emails',
    'Push Notification': 'push',
    'SMS / Text Message': 'textMessages',
    Viber: 'viber',
    'Facebook Ad': 'facebook/ads',
    'Whatsapp Message': 'whatsapp',
    'Google Ad': 'google/ads',
    Webhook: 'webhooks',
  };

  if (type in typeToButtonRedirectMap) {
    guidanceElements = <MarketingChannelsFlow elementTypes={elementTypes} element={element} type={type} />;
    buttonRedirect = typeToButtonRedirectMap[type];
  }

  const closeUserFlow = () => {
    if (newElement) {
      redirect && navigate(`/accounts/${accountId}/domains/${domainId}/${buttonRedirect}/${element.id}/details`);
    }
    setShow();
    setMarketingChannelsFlow(false);
  };

  return (
    <Modal
      opened={show}
      onClose={() => closeUserFlow()}
      size="lg"
      title={
        <span
          style={{
            width: '95%',
            textAlign: 'center',
            color: useInAutomation ? undefined : 'var(--mantine-color-green-6)',
          }}
        >
          {useInAutomation ? `How would you like to send your ${type}?` : `Your ${type} was saved successfully!`}
        </span>
      }
    >
      {!useInAutomation && (
        <Grid mt="lg" mb="lg">
          <Grid.Col span={{ base: 12 }}>
            <Title order={6} ta="center" mb="lg">What next?</Title>
            <Box ta="center" mb="lg">
              <Button
                size="lg"
                mr="sm"
                variant="default"
                onClick={(redirect) => {
                  redirect && navigate(`/accounts/${accountId}/domains/${domainId}/${buttonRedirect}`);
                }}
              >
                <IconChevronLeft size={14} /> Back To Listing
              </Button>
              <Button
                size="lg"
                variant="default"
                mr="sm"
                onClick={() => {
                  closeUserFlow();
                }}
              >
                <IconPencil size={14} /> Continue Editing
              </Button>

              <Button size="lg" onClick={() => setMarketingChannelsFlow(true)} variant="default">
                Send it <IconChevronRight size={14} />
              </Button>
            </Box>
          </Grid.Col>
        </Grid>
      )}
      {marketingChannelsFlow || useInAutomation ? (
        <Grid mb="sm">
          <Grid.Col span={{ base: 12 }}>
            {!useInAutomation && <Title order={6} ta="center">How would you like to send your {type}?</Title>}
            {guidanceElements}
          </Grid.Col>
        </Grid>
      ) : null}
    </Modal>
  );
};

export default GuidanceModal;
